import {AsyncPipe, NgForOf, NgIf} from '@angular/common';
import {HttpParams} from '@angular/common/http';
import {Component, ElementRef, HostListener, Input, OnInit, ViewChild} from '@angular/core';
import {FormControl, ReactiveFormsModule} from '@angular/forms';
import {ActivatedRoute, Params} from '@angular/router';
import {NbButtonModule, NbFormFieldModule, NbIconModule, NbInputModule} from '@nebular/theme';
import {BaseComponent, DamItem, StoreService} from 'compob2b-libs';
import {BehaviorSubject, Observable, of} from 'rxjs';
import {debounceTime, filter, map, switchMap, tap} from 'rxjs/operators';

@Component({
  standalone: true,
  selector: 'app-dam-search-elastic',
  templateUrl: './dam-search-elastic.component.html',
  imports: [
    NbIconModule,
    NbFormFieldModule,
    ReactiveFormsModule,
    NbInputModule,
    NbButtonModule,
    NgIf,
    AsyncPipe,
    NgForOf
  ],
  styleUrls: ['./dam-search-elastic.component.scss']
})
export class DamSearchElasticComponent extends BaseComponent implements OnInit {

  private readonly hiddenPanel$ = new BehaviorSubject<boolean>(false);
  inputFormControl: FormControl;
  terms$: Observable<DamItem[]>;
  termsLast$: Observable<DamItem[]>;
  terms: DamItem[];
  termsLast: DamItem[] = [];
  termsLastShow = false;
  termsExists = false;
  term: string;
  readonly hiddenPanelObservable$ = this.hiddenPanel$.asObservable();
  @ViewChild('autoCompleteInput') autoCompleteInput: ElementRef<HTMLElement>;
  @Input() typeCallback = 'redirect';
  @Input() placeholder = 'Поиск значений';
  showDamFilter: boolean;
  showDamFilterButton = false;

  constructor(protected readonly route: ActivatedRoute,
              private readonly elementRef: ElementRef,
              protected readonly storeService: StoreService
  ) {
    super();
  }

  ngOnInit(): void {
    this.showDamFilterButton = this.environment.showDamFilterButton;
    if (localStorage.getItem('showDamFilter') === undefined
      || localStorage.getItem('showDamFilter') === null
      || localStorage.getItem('showDamFilter') === 'undefined') {
      this.showDamFilter = false;
    } else {
      this.showDamFilter = !!localStorage.getItem('showDamFilter');
    }

    this.inputFormControl = new FormControl();
    this.route.queryParamMap
      .pipe(tap(_ => this.cdr.detectChanges()))
      .subscribe(param => this.inputFormControl.patchValue(param.get('keyword')));
    this.terms$ = this.inputFormControl.valueChanges
      .pipe(
        debounceTime(300),
        filter(term => term !== null),
        switchMap((term: string) => this.searchTerms(term))
      );
    this.cdr.detectChanges();
  }

  searchTerms(term: string): Observable<DamItem[]> {
    if ('' === term) {
      this.termsLast = [];
    }

    if (null === term || undefined === term) {
      return of([]);
    }

    if (term.length < 2) {
      this.termsLast$ = of([]);
      return of([]);
    }
    const url = '/dam/files/0/page/0/30/header/asc/';
    term = term.trim();

    const params = new HttpParams().set('keyword', term.toLowerCase());
    return this.compoApiService.getWithParams<any>(url, params).pipe(
      map(response => response.data.content),
      map(response => (response === null || 0 === response.length) ? [] : response)
      ,
      tap(data => {
        this.termsLast = data;
      })
      ,
      tap(_ => this.hideOrShowPanel())
    );

  }

  togglePanel(): void {
    this.hiddenPanel$.next(!this.hiddenPanel$.value);
    this.termsLastShow = !this.hiddenPanel$.value;
  }

  viewProduct(issue: DamItem) {
    this.router.navigate(['/'], {skipLocationChange: true})
      .then(() => this.router.navigate(['cabinet', 'dam', 'item', 'edit', issue.id]));
    this.hiddenPanel$.next(true);
  }

  private hideOrShowPanel(): void {
    /**
     * Case when there's the "keyword" param in url.
     * we don't need to show autocomplete panel.
     * Because keyword affects search input. And there's subscription on valueChanges().
     * See this.terms$ initialization and 86th line.
     */
    if (this.router.url.includes('keyword')) {
      this.hiddenPanel$.next(true);
    } else {
      this.hiddenPanel$.next(false);
    }

  }

  @HostListener('keydown.enter')
  searchByKeyword() {

    if (this.inputFormControl.value === '') {
      this.inputFormControl.patchValue('');
    }
    if (this.inputFormControl.value !== '') {
      const queryParams: Params = {keyword: this.inputFormControl.value, page: null};
      this.router.navigate(
        ['.'],
        {
          relativeTo: this.route,
          queryParams,
          queryParamsHandling: 'merge'
        }
      ).then(() => {
        this.hiddenPanel$.next(true);

      });
    }
  }

  @HostListener('document:keydown.escape')
  onEscapeHandler(): void {
    this.hiddenPanel$.next(true);
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: any): void {

    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.hiddenPanel$.next(true);
    }

  }

}
